<template>
  <div class="hp-boxes">
    <a
      class="hp-boxes--box"
      :style="`background-image:url(${$imageFolder}/${box.image})`"
      v-for="(box, index) in children"
      :key="box.id"
      :href="box.url || '#p'"
    >
      <!-- v-scroll-reveal="{ duration: 100 * (index + 5), delay: 50 * (index + 5) }" -->
      <!-- @mouseenter="mouseEnterHandler($event, index)"
      @mouseleave="mouseLeaveHandler($event, index)" -->

      <!-- @mousemove.self="moveHandler" -->
      <div
        class="hp-boxes--box--content box-content"
        :class="[activeBox === index ? 'active-box' : '']"
        :style="activeBox === index ? `opacity:${percentToCenterY}` : ''"
      >
        <h2 v-text="box.title"></h2>
        <span class="sep-line"></span>
        <h3 v-if="box.sub_title" v-text="box.sub_title"></h3>
        <a class="more-link mt-m text--s">
          <span v-text="localize('read_more')" />
          <i class="fal fa-chevron-right ml-xs"></i>
        </a>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    children: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      activeBox: -1,
      box: null,
      mouseOffsets: {
        y: null,
        x: null
      },
      percentToCenterY: null,
      percentToCenterX: null
    };
  },
  // mounted() {
  //   console.log(this.localize);
  // },
  methods: {
    moveHandler(e) {
      // console.log("mouse moving... ", e);
      this.$set(this, "mouseOffsets", { x: e.offsetX, y: e.offsetY });
      this.$set(
        this,
        "percentToCenterY",
        Math.max(0.3, this.computeToCenter(e.offsetY))
      );
      // console.log("percentToCenterY > ", this.percentToCenterY);
    },
    mouseEnterHandler(e, index) {
      let target = e.target,
        b = target.getBoundingClientRect();
      setTimeout(
        function() {
          this.activeBox = index;
          this.$set(this, "box", {
            top: b.top,
            left: b.left,
            width: b.width,
            height: b.height
          });
        }.bind(this),
        0
      );
    },
    mouseLeaveHandler() {
      this.activeBox = null;
      this.$set(this, "box", null);
      this.$set(this, "mouseOffsets", { x: null, y: null });
    },
    computeToCenter(coord) {
      let h = this.boxHeight;
      if (h && coord) {
        let _H = h / 2;
        return (_H - Math.abs(coord - _H)) / _H;
      }
      return 0;
    }
  },
  computed: {
    boxHeight() {
      let box = this.box;
      if (box) {
        return box.height;
      }
      return null;
    }
  }
};
</script>

<style lang="stylus" scoped>
.hp-boxes
  display grid
  grid-template-columns 1fr 1fr 1fr
  grid-template-rows repeat(3, 30vw)
  grid-auto-rows 30vw
  +below(768px)
    _flex(column, nowrap, center,center)
  &--box
    background-repeat no-repeat
    background-position center
    background-size cover
    cursor pointer
    _flex(column, wrap, center,center)
    +below(768px)
      flex 1
      width 100%
      height 40vh      
    &:nth-child(9n+1)
      grid-column:span 2
      grid-row: span 2
    &:nth-child(9n+2)
    &:nth-child(9n+3)
    &:nth-child(9n+4)
      grid-column:span 1
      grid-row:span 1
    &:nth-child(9n+5)
      grid-column:span 2
      grid-row:span 1
    &:nth-child(5n+1)
      .box-content
        background-color c_dk_blue
    &:nth-child(5n+2)
    &:nth-child(5n+5)
      .box-content
        background-color blue_6
    &--content
      background-color blue_4
      width 100%
      height 100%
      text-align center
      _flex(column, wrap, center,center)
      transition opacity 0.65s ease-out-expo, background 0.65s ease-out-expo
      &.active-box
        transition opacity 0.1s ease-out-expo
      .more-link
        color gray_0
        opacity 0
        _flex(row, nowrap, baseline, center)
        position relative
        transform translateY(-8px)
        transition opacity 0.45s ease-out, transform 0.65s ease-out-back
        i
          opacity 0
          font-size 70%
          position relative
          transform translateX(-250%)
          transition opacity 0.25s ease-out, transform 0.35s 0.1s ease-out-back
        +below(1100px)
          opacity 1
          transform translateY(0%)
          i
            transform translateX(0%)
            opacity 1
      h2
        text-align center
        max-width 73%
        text-transform uppercase
        color #fff
        font-size responsive 22px 48px
        font-range 768px 1900px
        line-height 1.1
        transition transform 0.4s ease-out-expo
      h3
        color rgba(#fff, 0.6)
        text-align center
        max-width 60%
        font-size responsive 16px 32px
        font-range 768px 1900px
        line-height 1.2
        transition transform 0.4s ease-out-expo
        +below(1100px)
          max-width 70%
      .sep-line
        max-width 200px
        width 60%
        margin 0 auto
        height 1px
        background #fff
        display block
        marg('l', y)
        transition width 0.25s ease-out-expo
    +below(1100px)
      .box-content
        background-color rgba(blue_4, 0.6)
      &:nth-child(5n+1)
        .box-content
          background-color rgba(c_dk_blue, 0.6)
      &:nth-child(5n+4)
      &:nth-child(5n+5)
        .box-content
          background-color rgba(blue_6, 0.6)
    +below(768px)
      .box-content
        border-bottom 1px solid rgba(#fff, 1)
        // border-top 1px solid rgba(gray_3, 0.6)
        background-color rgba(c_dk_blue, 0.6) !important
        padding 10vw
        h3
        h2
          color #fff
      // &:first-child
      //   .box-content
      //     border-top none
      &:last-child
        .box-content
          border-bottom none
    +desktop()
      &:hover
        .more-link
          opacity 1
          transform translateY(0%)
          i
            transform translateX(0%)
            opacity 1
        &:nth-child(5n+1)
          .box-content
            background-color rgba(c_dk_blue, 0.6)
        &:nth-child(5n+4)
        &:nth-child(5n+5)
          .box-content
            background-color rgba(c_dk_blue, 0.6)
        .box-content
          background-color rgba(c_dk_blue, 0.6)
        h2
          color #fff
          transform translateY(25%)
        h3
          color #fff
          transform translateY(-25%)
        .sep-line
          width 0%
</style>
